import { useState } from "react";
import { categories, comics } from "@/mocks/comics";
import ComicCard from "./ComicCard";
import { SectionHeading } from "./HotComics";

export default function Categories() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? comics : comics.filter((c) => c.category === active);

  return (
    <section className="mx-auto px-4 md:px-8 py-14 md:py-20 bg-background-900/50 border-y border-background-800/50">
      <SectionHeading
        anchor="categories"
        kicker="分类浏览 · CATEGORIES"
        title="海量韩漫免费分类，随心挑选"
        desc="从现代恋爱到古风宫斗，从重生逆袭到奇幻穿越，八大热门分类一应俱全，点击分类即可快速筛选心仪韩漫。"
      />

      {/* 分类筛选 */}
      <div className="flex flex-wrap gap-2 md:gap-3 mb-6 md:mb-8">
        <button
          onClick={() => setActive("全部")}
          className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors cursor-pointer ${
            active === "全部"
              ? "bg-primary-600 text-background-950 font-semibold"
              : "bg-background-800 text-foreground-300 hover:bg-background-700 hover:text-foreground-100"
          }`}
        >
          全部漫画
        </button>
        {categories.map((cat) => (
          <button
            key={cat.name}
            onClick={() => setActive(cat.name)}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors cursor-pointer ${
              active === cat.name
                ? "bg-primary-600 text-background-950 font-semibold"
                : "bg-background-800 text-foreground-300 hover:bg-background-700 hover:text-foreground-100"
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>

      {/* 分类说明卡 + 筛选结果 */}
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-3 md:gap-5">
        <aside className="lg:col-span-1 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-1 gap-3">
          {categories
            .filter((c) => c.name === active || active === "全部")
            .map((cat) => (
              <div
                key={cat.name}
                className="flex items-center gap-3 rounded-lg bg-background-800/70 border border-background-700/50 px-4 py-3"
              >
                <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-500/15 text-secondary-300">
                  <i className={`${cat.icon} text-xl`} />
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-100 truncate">{cat.name}</p>
                  <p className="text-xs text-foreground-500 truncate">{cat.desc}</p>
                </div>
              </div>
            ))}
        </aside>

        <div className="lg:col-span-3">
          {list.length > 0 ? (
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
              {list.map((c) => (
                <ComicCard key={c.id} comic={c} />
              ))}
            </div>
          ) : (
            <p className="rounded-lg bg-background-800 p-8 text-center text-foreground-400">
              该分类暂无作品，敬请期待更新。
            </p>
          )}
        </div>
      </div>
    </section>
  );
}